// CourseCard.js
import React from 'react';
import { Card, Typography, Flex } from 'antd';
import AssesmentCard from './AssesmentCard';
const { Text, Paragraph } = Typography;
interface CertificatePros {
  isLock: boolean;
  id: string;
  onAssesmentCardClick: (assesmentId: string) => any;
}
const CertificateCard = ({
  onAssesmentCardClick,
  isLock,
  id,
}: CertificatePros) => {
  return (
    <Flex
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        marginTop: '20px',
      }}
    >
      <AssesmentCard
        name={isLock ? 'Certificate' : 'Download'}
        id={id}
        isLocked={isLock}
        className={isLock ? '' : 'active'}
        //isComplete={assesment.is_attempted}// fixme complete
        onAssesmentCardClick={(assesmentId) =>
          onAssesmentCardClick(assesmentId)
        }
        imgSrc={
          isLock ? '/images/assesment-lock.png' : '/images/certificate.png'
        }
      />
    </Flex>
  );
};

export default CertificateCard;
